import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import '../styles/partnersSection/partnersSection.min.css';

const images = [
    '/images/partners-img/IPDJ.svg',
    '/images/partners-img/setubal.svg'
]

const Partners = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/como-ajudar');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
      <Container fluid className="p-0 section-separator w-100 m-0">
        <div className="partners-img-container d-flex justify-content-center align-items-center flex-column">
          <h2 className="bg-transp display-4 m-0">EMPRESA/ENTIDADE?</h2>
          <p className="bg-transp partners-description-text fw-bold display-6">
            Torna-te nosso parceiro e faz a diferença
          </p>
          <button
            type="button"
            className="main-btn fw-bold"
            onClick={handleClick}
          >
            Mais Informação
          </button>
        </div>
        <div className="d-flex flex-wrap justify-content-center py-5 text-center">
          <div className="w-100 w-md-33 d-flex align-items-center justify-content-center mb-3">
            <h3 className="display-5 fw-bold partners-heading">PARCERIAS</h3>
          </div>
          <div className="d-flex justify-content-center flex-wrap">
            {images.map((partner, index) => (
              <div
                key={index}
                className="w-50 w-sm-33 w-md-25 d-flex justify-content-center mb-3"
              >
                <img
                  className="partners-img img-fluid"
                  src={partner}
                  alt="Partner Logo"
                />
              </div>
            ))}
          </div>
        </div>
      </Container>
    );
}

export default Partners;